import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const CottageOptions = ({ value, onChange, id = 'CottageOptions', label = 'Cottage Options', disabled = false }) => {
    const defaultValue = value?.value || '';
    const [selectedOption, setSelectedOption] = useState(defaultValue);

    const cottageOptions = [
        { id: 1, value: '1/4', label: '1/4' },
        { id: 2, value: '1/3', label: '1/3' },
        { id: 3, value: '1/2', label: '1/2' },
    ];

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedOption(value?.value || '');
    }, [value?.value]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (cottageOptions.length > 0 && !selectedOption) {
            const defaultOption = cottageOptions[0];
            const newValue = defaultOption?.value || '';
            const newLabel = defaultOption?.label || '';
            setSelectedOption(newValue);
            onChange({ value: newValue, label: newLabel });
        }
    }, []);

    const handleOptionChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedOption(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedOption}
                onChange={handleOptionChange}
            >
                {cottageOptions.map(option => (
                    <option key={option.id} value={option.value}>
                        {selectedOption === option.value ? `${option.label} ✔` : option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default CottageOptions;
